/** Pure S012 chat-list state transitions. */
import type { ChatListEffect } from './effects';
import type { ChatListMsg } from './messages';
import {
  createLoadedModel,
  createLoadingModel,
  type ChatListModel,
} from './model';

export interface ChatListUpdateResult {
  readonly model: ChatListModel;
  readonly effects: readonly ChatListEffect[];
}

export function updateChatList(
  model: ChatListModel,
  message: ChatListMsg,
): ChatListUpdateResult {
  switch (message.type) {
    case 'LoadStarted':
      return {
        model: createLoadingModel(message.loadId),
        effects: [{ type: 'LoadConversations', loadId: message.loadId }],
      };

    case 'LoadSucceeded':
      if (message.loadId !== model.activeLoadId) {
        return { model, effects: [] };
      }
      return {
        model: createLoadedModel(message.loadId, message.conversations),
        effects: [],
      };

    case 'LoadInactiveSponsor':
      if (message.loadId !== model.activeLoadId) {
        return { model, effects: [] };
      }
      return {
        model: Object.freeze({
          status: 'inactive_sponsor',
          activeLoadId: message.loadId,
        }),
        effects: [],
      };

    case 'LoadFailed':
      if (message.loadId !== model.activeLoadId) {
        return { model, effects: [] };
      }
      return {
        model: Object.freeze({ status: 'error', activeLoadId: message.loadId }),
        effects: [],
      };
  }
}
